import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../pages/templates/sidebar.jsx";
import Topbar from "../pages/templates/topbar.jsx";

function DashboardLayout() {
  return (
    <div className="d-flex" id="wrapper">
      <Sidebar />
      <div
        className="flex-grow-1 d-flex flex-column min-vh-100"
        style={{ minWidth: 0 }}
      >
        <Topbar />
        <main className="flex-grow-1 p-3 p-md-4 bg-light">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
